import React from 'react';
import ProjectsSection from './projectScetion';
import Layout from './commonComp/layout';
export default function projects() {
  return (
    <div>
      <ProjectsSection />
    </div>
  );
}
